"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrlAccessToken = exports.useCirrusAccessTokenLogin = exports.ACCESS_TOKEN_URL_PARAM_KEY = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useCirrusLoginCredentials_1 = require("./useCirrusLoginCredentials");
exports.ACCESS_TOKEN_URL_PARAM_KEY = 'accessToken';
function useCirrusAccessTokenLogin() {
    const accessToken = useUrlAccessToken();
    return useCirrusLoginCredentials_1.useCirrusLoginCredentials(accessToken ? { accessToken } : null);
}
exports.useCirrusAccessTokenLogin = useCirrusAccessTokenLogin;
function useUrlAccessToken() {
    const { search } = react_router_dom_1.useLocation();
    const params = react_1.useMemo(() => new URLSearchParams(search), [search]);
    const token = react_1.useMemo(() => {
        var _a;
        if (params.has(exports.ACCESS_TOKEN_URL_PARAM_KEY)) {
            return (_a = params.get(exports.ACCESS_TOKEN_URL_PARAM_KEY)) !== null && _a !== void 0 ? _a : null;
        }
        else {
            return null;
        }
    }, [params]);
    return token;
}
exports.useUrlAccessToken = useUrlAccessToken;
//# sourceMappingURL=useCirrusAccessTokenLogin.js.map